import { useSelector } from 'react-redux';
import { StorePaymentDiscountDto } from '@tiendanube/common';
import { getStorePaymentDiscount } from '../../authSlice/authSelectors';

function useGetStorePaymentDiscount(): StorePaymentDiscountDto | null {
  return useSelector(getStorePaymentDiscount);
}

export default useGetStorePaymentDiscount;
